import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import PageTitle from '@/common/PageTitle/PageTitle';
import styles from '@/styles/inventory-activity.module.scss';
import pageStyles from './inventory-activity.module.scss';

const statCards = [
  { label: 'NEW ITEMS', value: 741, sub: 'Qty' },
  { label: 'NEW ORDERS', value: 123, sub: 'Qty' },
  { label: 'REFUNDS', value: 12, sub: 'Qty' },
  { label: 'MESSAGE', value: 1, sub: 'Qty' },
  { label: 'GROUPS', value: 4, sub: 'Qty' },
];

const topCategories = [
  { icon: '👕', label: 'Clothing' },
  { icon: '🤠', label: 'Hats' },
  { icon: '🛍️', label: 'Bags' },
  { icon: '🛒', label: 'Carts' },
  { icon: '📦', label: 'Boxes' },
  { icon: '👓', label: 'Glasses' },
];

const stores = [
  { name: 'Manchester, UK', employees: 23, items: 308, orders: 2 },
  { name: 'Yorkshire, UK', employees: 11, items: 291, orders: 15 },
  { name: 'Hull, UK', employees: 5, items: 41, orders: 11 },
  { name: 'Leicester, UK', employees: 16, items: 261, orders: 8 },
];

const InventoryActivity: React.FC = () => {
  return (
    <Container fluid>
      <Card className={pageStyles.card}>
        <Card.Body>
          <Card.Title className={pageStyles.cardTitle}>
            <PageTitle title="Recent Activity" />
          </Card.Title>
      <Row className={`mb-4 ${styles.statCardsRow}`}>
        {statCards.map((card, idx) => (
          <Col key={card.label} className={styles.statCard}>
            <Card className={styles.statCardContent}>
              <div className={styles.statValue}>{card.value}</div>
              <div className={styles.statSub}>{card.sub}</div>
              <div className={styles.statLabel}>{card.label}</div>
            </Card>
          </Col>
        ))}
      </Row>
      <Row className={styles.chartsRow}>
        {/* Sales and Top Item Categories side by side */}
        <Col md={8} lg={7} className={styles.salesChartCol}>
          <Card className={styles.card}>
            <Card.Body>
              <div className={styles.salesTitle}>Sales</div>
              {/* Simple bar chart mockup */}
              <div className={styles.barChart}>
                {[60, 80, 30, 100].map((h, i) => (
                  <div key={i} className={styles.bar} style={{ height: `${h}px` }}></div>
                ))}
              </div>
              <div className={styles.chartLabels}>
                <span>Confirmed</span>
                <span>Packed</span>
                <span>Refunded</span>
                <span>Shipped</span>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} lg={5} className={styles.categoriesCol}>
          <Card className={styles.card}>
            <Card.Body>
              <div className={styles.categoriesTitle}>
                Top item categories <span className={styles.viewAllLink}>VIEW ALL</span>
              </div>
              <div className={styles.categoriesGrid}>
                {topCategories.map((cat, idx) => (
                  <div key={cat.label} className={styles.categoryItem}>
                    <span>{cat.icon}</span>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* Stock numbers and Stores list side by side */}
      <Row className={styles.chartsRow}>
        <Col md={4} className={styles.stockCol}>
          <Card className={styles.stockCard}>
            <Card.Body className={styles.stockCardBody}>
              <div className={styles.stockTitle}>Stock numbers</div>
              <div className={styles.stockInfo}>
                <a href="#" className={styles.lowStockLink}>Low stock items</a> <span className={styles.stockInfoIcon}>12 ⓘ</span>
              </div>
              <div className={styles.stockItem}>Item categories <span className={styles.stockValue}>6</span></div>
              <div className={styles.stockItem}>Refunded items <span className={styles.stockValue}>1</span></div>
              <div className={styles.stockSpacer} /> {/* Spacer to push content to top and stretch height */}
            </Card.Body>
          </Card>
        </Col>
        <Col md={8} className={styles.storesCol}>
          <Card className={styles.stockCard}>
            <Card.Body>
              <div className={styles.storesTitle}>
                Stores list <span className={styles.viewAllLink}>VIEW ALL</span>
              </div>
              {stores.map((store) => (
                <div key={store.name} className={styles.storeRow}>
                  <span>{store.name}</span>
                  <span className={styles.storeEmployees}>{store.employees} employees</span>
                  <span>{store.items} items</span>
                  <span>{store.orders} orders</span>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default InventoryActivity; 